import React, { Component } from 'react';
import { InteractiveBrowserCredential } from "@azure/identity";
import { Button, Heading, DataTable, Text } from "grommet";

import PermissionHOC from "../../components/permissions";
import { SubscriptionManager } from "../../components/pushsubscription";
import LoginComponent from "../../components/Login";

let subscriptionmanager = null;
const getSubscriptionManager = props => {
  if(subscriptionmanager) return subscriptionmanager;
  subscriptionmanager = new SubscriptionManager({
    stati: props.stati,
    defaultAzureCredential: props.defaultAzureCredential
  });
  return subscriptionmanager;
}

class StatusPage extends Component {

  constructor() {
    super();

    this.onSubscribe = this.onSubscribe.bind(this);
    this.onUnsubscribe = this.onUnsubscribe.bind(this);
    this.onReady = this.onReady.bind(this);
    this.notificationButton = this.notificationButton.bind(this);
    this.login = this.login.bind(this);
    this.stati = {
      LOADING: 'LOADING',
      READY: 'READY',
      SUBSCRIBED: 'SUBSCRIBED',
      UNSUBSCRIBED: 'UNSUBSCRIBED',
      ERROR: 'ERROR'
    };

    this.state = {
      subscription: null,
      status: this.stati.LOADING,
      loggedin: null
    };
    this.sc = { scopes: ["api://720f8c6b-406e-473c-8f48-103c54ccbbc1/Channel.Read", "api://720f8c6b-406e-473c-8f48-103c54ccbbc1/Channel.Write"] };

    // SSR
    if(typeof window === "undefined") {
      return;
    }
  }

  componentDidMount() {
    getSubscriptionManager({ stati: this.stati, ...this.props }).addEventListener('subscribe', this.onSubscribe);
    getSubscriptionManager({ stati: this.stati, ...this.props }).addEventListener('unsubscribe', this.onUnsubscribe);
    getSubscriptionManager({ stati: this.stati, ...this.props }).addEventListener('ready', this.onReady);
    if(this.props.defaultAzureCredential.msalObject.getAccount()) { // get token, if already logged in
      this.login();
    }
    this.setState({
      loggedin: !!this.props.defaultAzureCredential.msalObject.getAccount()
    });
  }

  componentWillUnmount() {
    getSubscriptionManager({ stati: this.stati, ...this.props }).removeEventListener('subscribe', this.onSubscribe);
    getSubscriptionManager({ stati: this.stati, ...this.props }).removeEventListener('unsubscribe', this.onUnsubscribe);
    getSubscriptionManager({ stati: this.stati, ...this.props }).removeEventListener('ready', this.onReady);
  }

  onSubscribe({subscription}) {
    this.setState({
      subscription: subscription,
      status: this.stati.SUBSCRIBED
    })
  }

  onUnsubscribe({subscription}) {
    this.setState({
      subscription: subscription,
      status: this.stati.UNSUBSCRIBED
    })
  }

  onReady({ subscriptions, status }) {
    this.setState({
      status: status || this.stati.READY,
      subscriptions
    })
  }

  async login() {
    const prom = this.props.defaultAzureCredential.getToken(this.sc.scopes);
    //getSubscriptionManager().configure({ token: prom.then(({ token }) => token), defaultAzureCredential: this.defaultAzureCredential });
    const tkl = await prom;
    getSubscriptionManager({ stati: this.stati, ...this.props }).configure({ token: tkl.token, defaultAzureCredential: this.props.defaultAzureCredential });
    this.setState({
      loggedin: !!this.props.defaultAzureCredential.msalObject.getAccount()
    });
  }

  notificationButton({ state, request, appdetails }) {
    if(state === 'requested') {
      return <span data-state={state}>To enable notifications, please allow the website to show notifications!</span>
    }
    if(state === 'granted' || state === 'unknown') {
      return <Button padding="1rem" disabled={this.state.status === this.stati.LOADING} onClick={async () => {
        if(this.state.status === this.stati.SUBSCRIBED) {
          this.setState({ status: this.stati.LOADING });
          await getSubscriptionManager({ stati: this.stati, ...this.props }).unsubscribe();
        }
        else if(this.state.status === this.stati.UNSUBSCRIBED) {
          this.setState({ status: this.stati.LOADING });
          await getSubscriptionManager({ stati: this.stati, ...this.props }).subscribe()
        }
        await getSubscriptionManager({ stati: this.stati, ...this.props }).refresh();

      }} label={this.state.status === this.stati.LOADING ? "...." : `${
        this.state.status === this.stati.SUBSCRIBED ? "Unsubscribe" : ""}${
        this.state.status === this.stati.UNSUBSCRIBED ? "Subscribe" : ""
      } to all news channels`} />;
    }
    if(state === 'prompt') {
      return <Button padding="1rem" onClick={async () => {
        await request();
      }} label="Allow notifications" />
    }
    if(state === 'denied') {
      console.warn(`Notification permission denied!`);
      return <span data-state={state}>Notification permission denied - please update your browser settings to allow notifications!</span>
    }
    return <span data-state={state} />
  }

  render() {
    if(!this.state.loggedin) {
      return <Button padding="1rem" onClick={this.login} label="Log in"/>;
    }
    return (
      <div>
        <Heading level={1}>Notifications</Heading>

        <PermissionHOC appdetails={this.props.appdetails} options={{
          name:'notifications'
        }}>{this.notificationButton}</PermissionHOC>
        <Heading level={2}>Your notification subscriptions</Heading>
        <DataTable
          columns={[
            {
              property: 'name',
              header: <Text>Name</Text>,
              primary: true,
              search: true,
              sortable: true
            },
            {
              property: 'description',
              header: <Text>Description</Text>,
              search: true,
            },
            {
              property: 'type',
              header: <Text>Type</Text>,
              search: true,
              sortable: true
            },
            {
              property: 'subscription',
              header: <Text>Channels</Text>,
              search: true,
              sortable: true,
              render: ({ subscription: sub }) => (<>{sub.map(i => <b>{i}</b>).reduce((prev, curr) => [prev, ', ', curr])}</>),
            },
            {
              property: 'self',
              header: <Text>This browser?</Text>,
              search: true,
              sortable: true,
              render: ({ self }) => self ? "Yes" : "No",
            },
            {
              property: 'meta',
              header: <Text>Last Modified</Text>,
              search: true,
              sortable: true,
              render: ({ meta: { lastModified: lm } }) => <Text>{`${new Date(parseInt(lm)/1000)}`}</Text>,
            },
            {
              property: '_permissions',
              header: <Text>Owner</Text>,
              render: ({ _permissions: { __owner__: o } }) => <Text>{o}</Text>,
            },
          ]}
          data={this.state.subscriptions}
        />
        <Heading level={2}>Trigger a notification</Heading>
        <code><pre>
        {`
          fetch(\`https://contactchannel.azure-api.net/contactchannel/broadcast?subscription-key=$\{subscriptionkey}\`,
            {"headers":{
              "authorization":\`Bearer $\{jwt}\`, // either jwt from loging
              "x-md-authorization": \`$\{preauthheader}\` // or pre-authed authentication string
            },
            "body":JSON.stringify({
              channel: "<Channel.SubChannel.Topic>",
              message: "<Title>%$%$\{JSON.stringify(<notification-options>)}",
              limitations: { // any limitions towards potential receivers
                groupid: undefined,
                oid: undefined,
                uid: undefined,
                mdonly: true|false
              }
            }),
            "method":"POST"
          });
        `}
        </pre></code>
      </div>
    );
  }
}

export default () => {
  return <LoginComponent>{({ defaultAzureCredential }) => (<StatusPage defaultAzureCredential={defaultAzureCredential} />)}</LoginComponent>
}
